import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useSupabaseQuery } from '../../hooks/useSupabaseQuery';
import { PageHeader } from '../../components/ui/PageHeader';
import { EmptyState } from '../../components/ui/EmptyState';
import type { ProfesionalRow } from '../../types/database.types';

export function ProfesionalesList() {
  const { data, loading, error } = useSupabaseQuery<ProfesionalRow[]>(async () =>
    supabase.from('profesionales').select('*').neq('estado', 'anulado').order('nombre', { ascending: true }),
  );

  return (
    <div>
      <PageHeader
        title="Profesionales"
        description="Equipo del salón y los servicios que cada una puede realizar"
        actions={
          <Link to="/admin/profesionales/nuevo" className="btn-primary">
            Nueva profesional
          </Link>
        }
      />

      {loading && <p className="text-sm text-onyx/50">Cargando…</p>}
      {error && <p className="text-sm text-red-600">{error}</p>}

      {data && data.length === 0 && (
        <EmptyState title="No hay profesionales registradas" description="Crea la primera desde el botón de arriba." />
      )}

      {data && data.length > 0 && (
        <div className="card overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-onyx/10 text-left text-onyx/50">
                <th className="px-4 py-3 font-medium">Nombre</th>
                <th className="px-4 py-3 font-medium">Teléfono</th>
                <th className="px-4 py-3 font-medium">Vinculación</th>
                <th className="px-4 py-3 font-medium">Estado</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody>
              {data.map((p) => (
                <tr key={p.id} className="border-b border-onyx/5 last:border-0 hover:bg-onyx/[0.02]">
                  <td className="px-4 py-3 font-medium text-onyx">{p.nombre}</td>
                  <td className="px-4 py-3 text-onyx/70">{p.telefono ?? '—'}</td>
                  <td className="px-4 py-3 text-onyx/70">{p.tipo_vinculacion ?? '—'}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`badge ${
                        p.estado === 'activo' ? 'bg-green-100 text-green-800' : 'bg-gray-200 text-gray-700'
                      }`}
                    >
                      {p.estado}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/admin/profesionales/${p.id}`} className="text-gold-deep hover:underline">
                      Editar
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
